/**
 * @module lib/actions
 * Utilities for [Flux Standard Actions]{@link https://github.com/redux-utilities/flux-standard-action}.
 */

/**
 * Create a FSA.
 * @param {string} type
 * @param {boolean} [error]
 * @param {any} [payload]
 * @param {any} [meta]
 */
export function createAction(type, error, payload, meta) {
  if (error !== true) {
    error = false;
  }
  return { type, error, payload, meta };
}



// WEBPACK FOOTER //
// ./src/lib/actions/index.js